(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eba-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.eba-product-page');

    roots.forEach((root) => {
      const variantsNode = root.querySelector('[data-eba-variants]');
      const form = root.querySelector('.eba-product-form');

      if (!variantsNode || !form) {
        return;
      }

      let variants = [];

      try {
        variants = JSON.parse(variantsNode.textContent || '[]');
      } catch (error) {
        variants = [];
      }

      const currency = root.dataset.currency || 'USD';
      const idInput = form.querySelector('[data-variant-id]');
      const addButtons = root.querySelectorAll('[data-eba-add], [data-eba-sticky-submit]');
      const stickyButton = root.querySelector('[data-eba-sticky-submit]');

      const formatMoney = (cents) => {
        try {
          return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100);
        } catch (error) {
          return `$${(cents / 100).toFixed(2)}`;
        }
      };

      const selectedOptions = () => {
        return Array.from(root.querySelectorAll('[data-option-group]')).map((group) => {
          const selected = group.querySelector('input[type="radio"]:checked');
          return selected ? selected.value : '';
        });
      };

      const matchingVariant = () => {
        const options = selectedOptions();

        if (!options.length) {
          return variants[0];
        }

        return variants.find((variant) => {
          return variant.options.every((option, index) => option === options[index]);
        });
      };

      const setText = (selector, text) => {
        root.querySelectorAll(selector).forEach((element) => {
          element.textContent = text;
        });
      };

      const updateVariant = () => {
        const variant = matchingVariant();

        if (!variant) {
          return;
        }

        if (idInput) {
          idInput.value = variant.id;
        }

        setText('[data-eba-price]', formatMoney(variant.price));
        setText('[data-eba-sticky-price]', formatMoney(variant.price));
        setText('[data-eba-availability]', variant.available ? root.dataset.stockLabel : 'Sold out');

        root.querySelectorAll('[data-eba-compare]').forEach((element) => {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            element.hidden = false;
            element.textContent = formatMoney(variant.compare_at_price);
          } else {
            element.hidden = true;
          }
        });

        addButtons.forEach((button) => {
          button.disabled = !variant.available;
          button.textContent = variant.available ? (button.hasAttribute('data-eba-sticky-submit') ? 'Buy' : 'Add to Cart') : 'Sold Out';
        });
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('.eba-option-input')) {
          updateVariant();
        }
      });

      if (stickyButton) {
        stickyButton.addEventListener('click', () => {
          const submitButton = form.querySelector('[data-eba-add]');

          if (form.requestSubmit && submitButton) {
            form.requestSubmit(submitButton);
            return;
          }

          if (submitButton) {
            submitButton.click();
          }
        });
      }

      updateVariant();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
